import { useEffect, useState } from 'react';

import { AboutMemberPayload, MemberPayload } from '../services/advisoryService';
import { fetchAboutMember, fetchMembers } from '../services/advisoryService';

export const useAdvisory = () => {
  const [aboutMember, setAboutMember] = useState<AboutMemberPayload | null>(null);
  const [members, setMembers] = useState<MemberPayload[]>([]);

  useEffect(() => {
    let isMounted = true;

    const loadAdvisoryData = async () => {
      try {
        const [aboutMemberData, membersData] = await Promise.all([
          fetchAboutMember(),
          fetchMembers()
        ]);
        
        if (isMounted) {
          setAboutMember(aboutMemberData);
          setMembers(membersData);
        }
      } catch (error) {
        console.error('Failed to load advisory content', error);
      }
    };

    loadAdvisoryData();

    return () => {
      isMounted = false;
    };
  }, []);

  return { aboutMember, members };
};
